import { useCallback } from 'react';

import type { DealItem } from '@/lib/graphql/generated/graphql';
import type { ColumnSort } from '@tanstack/react-table';
import { atom, useAtom } from 'jotai';

export enum ColumnSortId {
  name = 'name',
  position = 'position',
  stockQuantity = 'stockQuantity',
}

export const columnSortState = atom<ColumnSort[]>([
  {
    id: ColumnSortId.position,
    desc: false,
  },
]);

export const tableSortResetSignalState = atom(0);

export function useSetColumnSort() {
  const [columnSorts, setColumnSorts] = useAtom(columnSortState);

  const setColumnSort = useCallback(
    (columnId: keyof DealItem) => {
      setColumnSorts((previous) => {
        const existingSort = previous.find((sort) => sort.id === columnId);
        const newDesc = existingSort ? !existingSort.desc : false;
        return [{ id: columnId, desc: newDesc }];
      });
    },
    [setColumnSorts]
  );

  return {
    getColumnSort: (columnId: keyof DealItem) =>
      columnSorts.find((sort) => sort.id === columnId) as
        | ColumnSort
        | undefined,
    setColumnSort,
  };
}
